"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = exports.SiteType = exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["ACCOUNT"] = "account_overview";
    PageType["ACCOUNT_AFTER_LOGIN"] = "account_overview_after_login";
    PageType["ACCOUNT_AFTER_REGISTRATION"] = "account_overview_after_registration";
    PageType["ACCOUNT_CHANGE_DATE_OF_BIRTH"] = "changeDateOfBirth";
    PageType["ACCOUNT_CHANGE_BILLING_ADDRESS"] = "billing_address";
    PageType["ACCOUNT_CHANGE_EMAIL"] = "changeEmail";
    PageType["ACCOUNT_CHANGE_PASSWORD"] = "change_passsword";
    PageType["ACCOUNT_COPAYMENT_REPORT"] = "account_copayment_report";
    PageType["ACCOUNT_NEWSLETTER"] = "account_newsletter";
    PageType["ACCOUNT_ORDER"] = "account_orders";
    PageType["ACCOUNT_ORDER_DETAILS"] = "account_orders_details";
    PageType["ORDER_CANCELLABLE"] = "cancellable";
    PageType["CART"] = "cart";
    PageType["CART_INTERMEDIATE"] = "cartintermediate";
    PageType["CHECKOUT_ADDRESS"] = "checkout_address";
    PageType["CHECKOUT_ADDRESS_AFTER_LOGIN"] = "checkout_address_after_login";
    PageType["CHECKOUT_ADDRESS_AFTER_REGISTRATION"] = "checkout_address_after_registration";
    PageType["CHECKOUT_CONFIRMATION"] = "checkout_confirmation";
    PageType["CHECKOUT_DELIVERY"] = "checkout_delivery";
    PageType["CHECKOUT_PAYMENT"] = "checkout_payment";
    PageType["CHECKOUT_VERIFICATION"] = "checkout_verification";
    PageType["CUSTOMER_ACCOUNT"] = "customer_account";
    PageType["DAMAGED_PRODUCTS"] = "damaged_products";
    PageType["DAMAGED_PRODUCT_CONTACT"] = "damaged_product_contact";
    PageType["PRODUCTS_CANCELLATION"] = "products_cancellation";
    PageType["DAMAGED_PRODUCTS_CONFIRMATION"] = "damaged_products_confirmation";
    PageType["DAMAGED_PRODUCTS_CUSTOMER_CARE"] = "damaged_products_customer_care";
    PageType["DELETE_ACCOUNT"] = "delete_account";
    PageType["ERX_LANDING_PAGE"] = "erx_landing_page";
    PageType["FORGOT_PASSWORD"] = "forgot_password";
    PageType["HOME"] = "home";
    PageType["HELP_CENTER"] = "help_center";
    PageType["HELP_CENTER_ORDER_QUESTIONS"] = "order_questions";
    PageType["HELP_CENTER_OTHER_TOPICS"] = "other_topics";
    PageType["INTERACTIONS_RESULTS"] = "interactions_results";
    PageType["INTERACTIONS_SEARCH"] = "interactions_search";
    PageType["LEAFLET_SEARCH"] = "leaflet_search";
    PageType["LOGIN"] = "login";
    PageType["MARKETING"] = "marketing";
    PageType["MARKETPLACE_PARTNER_REGISTER"] = "marketplace_reg";
    PageType["MISSING_PRODUCTS_CONTACT"] = "missing_product_contact";
    PageType["MISSING_PRODUCTS"] = "missing_products";
    PageType["MISSING_PRODUCTS_CONFIRMATION"] = "missing_products_confirmation";
    PageType["PRODUCTS_CANCELLATION_CONFIRMATION"] = "products_cancellation_confirmation";
    PageType["MISSING_PRODUCTS_CUSTOMER_CARE"] = "missing_products_customer_care";
    PageType["PRODUCTS_CANCELLATION_CUSTOMER_CARE"] = "products_cancellation_customer_care";
    PageType["NEWSLETTER"] = "newsletter";
    PageType["NEWSLETTER_UNSUBSCRIBE"] = "newsletter_unsubscribe";
    PageType["NEWSLETTER_CONFIRMATION"] = "newsletter_confirmation";
    PageType["NFC_LANDING_PAGE"] = "nfc_landing_page";
    PageType["OFFER"] = "offer";
    PageType["ORDER_CHANGE"] = "order_change";
    PageType["PARTNER_PRODUCTS"] = "seller_products";
    PageType["PAYMENT_DEFERRAL"] = "payment_deferral";
    PageType["PAYMENT_REMINDER"] = "payment_reminder";
    PageType["PDP"] = "product";
    PageType["PDP_AFTER_LOGIN"] = "pdp_after_login";
    PageType["PDP_AFTER_REGISTRATION"] = "pdp_after_registration";
    PageType["PHARMA_TOPICS"] = "pharma_topics";
    PageType["RESET_PASSWORD"] = "resetPassword";
    PageType["RETURN_ITEM"] = "return_item";
    PageType["RX_LANDING_PAGE"] = "rx_landing_page";
    PageType["SEARCH_RESULTS"] = "search";
    PageType["BRANDS"] = "brands";
})(PageType || (exports.PageType = PageType = {}));
/**
 * siteType
 */
var SiteType;
(function (SiteType) {
    SiteType["ACCOUNT"] = "account_overview";
    SiteType["ACCOUNT_AFTER_LOGIN"] = "account_overview";
    SiteType["ACCOUNT_AFTER_REGISTRATION"] = "account_overview";
    SiteType["ACCOUNT_CHANGE_BILLING_ADDRESS"] = "billing_address";
    SiteType["ACCOUNT_CHANGE_DATE_OF_BIRTH"] = "changeDateOfBirth";
    SiteType["ACCOUNT_CHANGE_EMAIL"] = "changeEmail";
    SiteType["ACCOUNT_CHANGE_PASSWORD"] = "change_password";
    SiteType["ACCOUNT_COPAYMENT_REPORT"] = "account_copayment_report";
    SiteType["ACCOUNT_DELETE"] = "help_center";
    SiteType["ACCOUNT_NEWSLETTER"] = "newsletter";
    SiteType["ACCOUNT_ORDER"] = "account_orders";
    SiteType["ACCOUNT_ORDER_DETAILS"] = "account_orders";
    SiteType["ORDER_CANCELLABLE"] = "cancellable";
    SiteType["CART"] = "cart";
    SiteType["CART_INTERMEDIATE"] = "add_to_cart";
    SiteType["CHECKOUT_ADDRESS"] = "checkout_address";
    SiteType["CHECKOUT_ADDRESS_AFTER_LOGIN"] = "checkout_address";
    SiteType["CHECKOUT_ADDRESS_AFTER_REGISTRATION"] = "checkout_address";
    SiteType["CHECKOUT_CONFIRMATION"] = "checkout_confirmation";
    SiteType["CHECKOUT_DELIVERY"] = "checkout_address";
    SiteType["CHECKOUT_PAYMENT"] = "checkout_payment";
    SiteType["CHECKOUT_VERIFICATION"] = "checkout_verification";
    SiteType["CUSTOMER_ACCOUNT"] = "help_center";
    SiteType["DAMAGED_PRODUCT_CONTACT"] = "damaged_product_contact";
    SiteType["DELETE_ACCOUNT"] = "help_center";
    SiteType["ERX_LANDING_PAGE"] = "eRx";
    SiteType["FORGOT_PASSWORD"] = "forgot-password";
    SiteType["HOME"] = "home";
    SiteType["HELP_CENTER"] = "help_center";
    SiteType["HELP_CENTER_ORDER_QUESTIONS"] = "help_center";
    SiteType["HELP_CENTER_OTHER_TOPICS"] = "help_center";
    SiteType["INTERACTIONS_RESULTS"] = "interactioncheck";
    SiteType["INTERACTIONS_SEARCH"] = "interactioncheck";
    SiteType["LEAFLET_SEARCH"] = "leaflets";
    SiteType["LOGIN"] = "login";
    SiteType["MARKETING"] = "marketing";
    SiteType["MARKETPLACE_PARTNER_REGISTER"] = "marketplace_reg";
    SiteType["MISSING_PRODUCTS_CONTACT"] = "missing_product_contact";
    SiteType["NEWSLETTER"] = "newsletter";
    SiteType["NEWSLETTER_UNSUBSCRIBE"] = "newsletter";
    SiteType["NEWSLETTER_CONFIRMATION"] = "newsletter";
    SiteType["NFC_LANDING_PAGE"] = "eRx";
    SiteType["OFFER"] = "offer";
    SiteType["ORDER_CHANGE"] = "order_change";
    SiteType["PARTNER_PRODUCTS"] = "seller_products";
    SiteType["PAYMENT_DEFERRAL"] = "payment_deferral";
    SiteType["PAYMENT_REMINDER"] = "payment_reminder";
    SiteType["PDP"] = "product";
    SiteType["PDP_AFTER_LOGIN"] = "product";
    SiteType["PDP_AFTER_REGISTRATION"] = "product";
    SiteType["PHARMA_TOPICS"] = "help_center";
    SiteType["RETURN_ITEM"] = "return_item";
    SiteType["RESET_PASSWORD"] = "resetPassword";
    SiteType["RX_LANDING_PAGE"] = "rx_landing_page";
    SiteType["SEARCH_RESULTS"] = "search";
    SiteType["BRANDS"] = "brands";
})(SiteType || (exports.SiteType = SiteType = {}));
/**
 * contentType
 */
var ContentType;
(function (ContentType) {
    ContentType["ACCOUNT"] = "Mein Konto/Ihre \u00DCbersicht";
    ContentType["ACCOUNT_AFTER_LOGIN"] = "Mein Konto/Ihre \u00DCbersicht";
    ContentType["ACCOUNT_AFTER_REGISTRATION"] = "Mein Konto/Ihre \u00DCbersicht";
    ContentType["ACCOUNT_CHANGE_BILLING_ADDRESS"] = "Billing Address";
    ContentType["ACCOUNT_CHANGE_DATE_OF_BIRTH"] = "Mein Konto/Geburtsdatum \u00E4ndern";
    ContentType["ACCOUNT_CHANGE_EMAIL"] = "Mein Konto/E-Mail-Adresse \u00E4ndern";
    ContentType["ACCOUNT_CHANGE_PASSWORD"] = "Mein Konto/Passwort \u00E4ndern";
    ContentType["ACCOUNT_COPAYMENT_DOCUMENT"] = "Account/Copayment/Document";
    ContentType["ACCOUNT_COPAYMENT_REPORT_INSURANCE_EMPTY"] = "Account/Copayment/Insurance_Empty";
    ContentType["ACCOUNT_COPAYMENT_REPORT_INSURANCE_FILLED"] = "Account/Copayment/Insurance_Filled";
    ContentType["ACCOUNT_COPAYMENT_REPORT_TAX_EMPTY"] = "Account/Copayment/Tax_Empty";
    ContentType["ACCOUNT_COPAYMENT_REPORT_TAX_FILLED"] = "Account/Copayment/Tax_Filled";
    ContentType["ACCOUNT_NEWSLETTER"] = "Account Newsletter/Ihr pers\u00F6nlicher Newsletter";
    ContentType["ACCOUNT_ORDER"] = "Mein Konto/Bestellhistorie";
    ContentType["ACCOUNT_ORDER_DETAILS"] = "Mein Konto/Bestellhistorie Details";
    ContentType["CART"] = "Mein Warenkorb";
    ContentType["CART_INTERMEDIATE"] = "Produkt in den Warenkorb gelegt";
    ContentType["CHECKOUT_ADDRESS"] = "Rechnungsadresse";
    ContentType["CHECKOUT_ADDRESS_AFTER_LOGIN"] = "Rechnungsadresse";
    ContentType["CHECKOUT_ADDRESS_AFTER_REGISTRATION"] = "Rechnungsadresse";
    ContentType["CHECKOUT_CONFIRMATION"] = "Bestellung abgeschlossen";
    ContentType["CHECKOUT_DELIVERY"] = "Lieferadresse";
    ContentType["CHECKOUT_PAYMENT"] = "Zahlarten";
    ContentType["CHECKOUT_VERIFICATION"] = "Bestellung Kontrollieren";
    ContentType["CUSTOMER_ACCOUNT"] = "Help-Center/Account";
    ContentType["ERX_LANDING_PAGE"] = "eRx/Landingpage";
    ContentType["FORGOT_PASSWORD"] = "Forgot password";
    ContentType["DAMAGED_PRODUCT_CONTACT"] = "Help-Center/Account/damaged-product-contact";
    ContentType["DAMAGED_PRODUCTS"] = "Help-Center/Account/damaged-products";
    ContentType["DAMAGED_PRODUCTS_CONFIRMATION"] = "Help-Center/Account/damaged-products-confirmation";
    ContentType["DAMAGED_PRODUCTS_CUSTOMER_CARE"] = "Help-Center/Account/damaged-products-customer-care";
    ContentType["PRODUCTS_CANCELLATION"] = "Help-Center/Account/products-cancellation";
    ContentType["PRODUCTS_CANCELLATION_CONFIRMATION"] = "Help-Center/Account/products-cancellation-confirmation";
    ContentType["PRODUCTS_CANCELLATION_CUSTOMER_CARE"] = "Help-Center/Account/products-cancellation-customer-care";
    ContentType["DELETE_ACCOUNT"] = "Help-Center/Account/delete-account";
    ContentType["HELP_CENTER"] = "Help-Center/Main";
    ContentType["HELP_CENTER_ORDER_QUESTIONS"] = "Help-Center/Orders/order-questions";
    ContentType["HELP_CENTER_OTHER_TOPICS"] = "Help-Center/Other-Topics";
    ContentType["HOME"] = "Startseite";
    ContentType["INTERACTIONS_RESULTS"] = "Interactioncheck/results";
    ContentType["INTERACTIONS_SEARCH"] = "Interactioncheck/main";
    ContentType["LEAFLET_SEARCH"] = "Leaflets/main";
    ContentType["LOGIN"] = "Anmeldung";
    ContentType["MARKETING"] = "Marketing";
    ContentType["MARKETPLACE_PARTNER_REGISTER"] = "Marketplace Registration";
    ContentType["MISSING_PRODUCTS_CONTACT"] = "missing_product_contact";
    ContentType["NEWSLETTER"] = "Newsletter/Ihr pers\u00F6nlicher Newsletter";
    ContentType["NEWSLETTER_UNSUBSCRIBE"] = "Newsletter Abmeldung";
    ContentType["NEWSLETTER_CONFIRMATION"] = "Newsletter Confirmation";
    ContentType["NFC_LANDING_PAGE"] = "eRx/NFC-Landingpage";
    ContentType["OFFER"] = "Offerseite";
    ContentType["ORDER_CHANGE"] = "order_change";
    ContentType["PARTNER_PRODUCTS"] = "Verk\u00E4ufer Produkte";
    ContentType["PDP"] = "Produktdetailseite";
    ContentType["PDP_AFTER_LOGIN"] = "Produktdetailseite";
    ContentType["PDP_AFTER_REGISTRATION"] = "Produktdetailseite";
    ContentType["PHARMA_TOPICS"] = "Help-Center/Pharma-Topics";
    ContentType["RX_LANDING_PAGE"] = "Rx/Redemption";
    ContentType["RESET_PASSWORD"] = "Passwort \u00E4ndern";
    ContentType["SEARCH_RESULTS"] = "Suchseite";
    ContentType["BRANDS"] = "Marken";
})(ContentType || (exports.ContentType = ContentType = {}));
//# sourceMappingURL=enums.js.map